import { event } from 'd3';
import { sankeyLayer } from './sankeyLayer';
import { computeHovered } from './computeHovered';
import { computeSankey } from './computeSankey';
import * as d3 from 'd3';


export function sankeyDiagram(selection, props) {
  const {
    data,
    width,
    height,
    margin,
    nodePadding,
    nodeWidth,
    hover,
    pre,
    city
  } = props;

  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;

  const { nodes, links } = computeSankey(selection, {
    data,
    nodeWidth,
    nodePadding,
    innerWidth: innerWidth/1.15,
    innerHeight,
    city
  });

  let defs = d3.select("#" + pre + "regional-sankey-defs");
  let baseScale = d3.scaleOrdinal(["#E4D024", "#BDD414", "#48C16E", "#2DBCBC", "#228D8D", "#6380A6", "#CD83A8", "#BE63AC", "#9B5DB6", "#5D6CBB"]);

  let colorScheme = (root) => {
    if (root.indexOf('-') >= 0) {
      let gradient_id = root.replace(/\W/g, '');
      if (d3.selectAll("#" + pre + gradient_id)._groups[0].length === 0) {
        let s = root.split('-');
        // make the colors consistent for the vancouver 2011 graph
        if (s[1] === '  Christian' && city === "vancouver2011") {
          colorScheme("Other");
        } 
        let c1 = baseScale(s[0]);
        let c2 = baseScale(s[1]);

        var gradient = defs.append("linearGradient")
          .attr("id", pre + gradient_id)
          .attr("x1", "0%")
          .attr("x2", "100%")
          .attr("y1", "0%")
          .attr("y2", "0%");

        gradient.append("stop")
          .attr('class', 'start')
          .attr("offset", "0%")
          .attr("stop-color", c2)
          .attr("stop-opacity", 1);

        gradient.append("stop")
          .attr('class', 'end')
          .attr("offset", "100%")
          .attr("stop-color", c1)
          .attr("stop-opacity", 1);
      }

      return "url(#" + gradient_id + ")";
    } else {
      return baseScale(root);
    }
  }

  props.colorScheme = colorScheme;

  const backLayer = selection.selectAll('.back-layer').data([null]);
  backLayer
    .enter().append('g').attr('class', 'back-layer small')
      .call(sankeyLayer, Object.assign({}, props, {
        nodes,
        links,
        innerWidth,
        hover,
        pre
      }))

  backLayer
    .call(sankeyLayer, Object.assign({}, props, {
      nodes,
      links,
      innerWidth,
      hover,
      pre
    }))
}



// WEBPACK FOOTER //
// ./src/Sankey/sankeyDiagram.js